import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { loginRedirectPrivider } from '../../services/auth';

type Props = {
  open: boolean;
  message: string;
  onClose: () => void;
};

const useStyles = makeStyles(() => ({
  title: {
    color: '#373F41',
  },
  loginButton: {
    backgroundColor: '#0F6FB7',
    color: '#fff',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#0c5a94',
    },
  },
}));

export default function AssinaturaSessaoExpiradaDialog({
  open,
  message,
  onClose,
}: Props): JSX.Element {
  const classes = useStyles();
  const location = useLocation();

  const handleLogin = () => {
    loginRedirectPrivider(`${location.pathname}${location.search}`);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle className={classes.title}>Sessão expirada</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='default'>
          Fechar
        </Button>
        <Button
          variant='contained'
          className={classes.loginButton}
          onClick={handleLogin}
        >
          Fazer login
        </Button>
      </DialogActions>
    </Dialog>
  );
}
